import Vue from "vue";
import Router from "vue-router";
import Homepage from "@/pages/Homepage.vue";
import Documentation from "@/pages/Documentation.vue";
import Datasets from "@/pages/Datasets.vue";
import Error from "@/pages/Error.vue";
import i18n from "@/plugins/i18n.js";
import { DEFAULT_LOCALE } from "@/constants";

Vue.use(Router);

import locale from "element-ui/lib/locale";
import langEn from "element-ui/lib/locale/lang/en";
import langCs from "element-ui/lib/locale/lang/cs-CZ";

const locales = { cs: langCs, en: langEn };

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: {
        render(h) {
          return h("router-view");
        }
      },
      beforeEnter(to, from, next) {
        if (i18n.locale !== DEFAULT_LOCALE) {
          i18n.locale = DEFAULT_LOCALE;
        }
        locale.use(locales[i18n.locale]);

        return next();
      },
      children: [
        {
          path: "",
          name: "home",
          component: Homepage
        },
        {
          path: "documentation",
          name: "documentation",
          component: Documentation
        },
        {
          path: "datasets",
          name: "datasets",
          component: Datasets
        },
        {
          path: "error",
          name: "error",
          component: Error
        }
      ]
    },
    {
      path: "/:lang",
      props: true,

      component: {
        render(h) {
          return h("router-view");
        }
      },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;

        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        locale.use(locales[i18n.locale]);

        return next();
      },
      children: [
        {
          path: "",
          name: "localized-home",
          component: Homepage,
          props: true
        },
        {
          path: "documentation",
          name: "localized-documentation",
          component: Documentation,
          props: true
        },
        {
          path: "datasets",
          name: "localized-datasets",
          component: Datasets,
          props: true
        }
      ]
    }
  ]
});
